import { StyleSheet } from 'react-native';

const QAAnswer1Image = ({ style }) => {
  const oneX = require('./NotAtAll.jpg');
  const twoX = require('./NotAtAll@2x.jpg');
  return (
    <img
      src={twoX}
      alt=""
      style={{ ...StyleSheet.flatten(style), objectFit: 'contain' }}
      srcSet={`${oneX}, ${twoX} 2x`}
    />
  );
};

export { QAAnswer1Image };
